import UltMeta, { Meta } from "./UltMeta/index";
/**
 * 认证三要素认证状态
 */
class VerificationAuthState extends UltMeta {
    ALL_CONSISTENT = new Meta("1", "三要素验证均一致");
    PHONE_INCONSISTENT = new Meta("2", "姓名和身份证一致，和手机号不一致");
    NAME_ID_INCONSISTENT = new Meta("3", "姓名和身份证不一致");
}

export const  VERIFICATION_AUTH_STATE = new VerificationAuthState();


